import { io, Socket } from "socket.io-client";
import { getShop } from "@/utils/auth.ts";
import { getToken } from "./helper";

const shop = getShop();
const businessId = shop?._id ? shop._id : "";

const token = getToken();

const socket: Socket = io(
  `${import.meta.env.VITE_SOCKET_URL}/ordering-${businessId}`,
  {
    auth: {
      token: token,
    },
    autoConnect: false,
    reconnection: true, // Enable reconnection (true by default)
    reconnectionAttempts: 5, // Limit to 5 retry attempts
    reconnectionDelay: 3000, // 3 seconds delay before trying again
    // transports: ["websocket", "polling"]
  },
);

export default socket;
